export const ShimmerYoutubePreview = ({ count = 5 }) => {
  return (
    <section className="mt-10 px-4 sm:px-6 animate-pulse">
      {/* Header */}
      <div className="mb-4">
        <div className="h-6 w-48 bg-slate-200 rounded mb-2"></div>
        <div className="h-4 w-64 bg-slate-200 rounded"></div>
      </div>

      {/* Horizontal Slider */}
      <div className="flex gap-3 overflow-x-auto pb-2">
        {[...Array(count)].map((_, i) => (
          <div
            key={i}
            className="w-[250px] sm:w-[300px] lg:w-[340px] shrink-0 rounded-xl bg-white shadow-sm ring-1 ring-slate-100 overflow-hidden"
          >
            {/* Thumbnail */}
            <div className="h-44 w-full bg-slate-200"></div>

            {/* Optional text line (if you add title later) */}
            <div className="p-3 space-y-2">
              <div className="h-3 w-3/4 bg-slate-200 rounded"></div>
              <div className="h-3 w-1/2 bg-slate-200 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

